var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "copy_svg__bg",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy_svg__stroke",
    d: "M13.1719 18.8287L18.8287 13.1719M11.0506 15.293L9.63642 16.7072C8.07432 18.2693 8.07432 20.8019 9.63642 22.364C11.1985 23.9261 13.7312 23.9261 15.2933 22.364L16.7075 20.9498M15.293 11.0501L16.7072 9.63593C18.2693 8.07383 20.8019 8.07383 22.364 9.63593C23.9261 11.198 23.9261 13.7307 22.364 15.2928L20.9498 16.707",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCopy;